import { env } from "@/config/env";
import { externalLinks } from "@/constants/links";
import { PRODUCTS_MENU_LINKS } from "@/components/ProductsMenu/constants";
import { SOLUTIONS_MENU_LINKS } from "../Header/constants";
export const SOCIAL_LINKS = [
  {
    icon: "x",
    url: "https://twitter.com/mintology_app",
  },
  {
    icon: "linkedin",
    url: "https://www.linkedin.com/company/mintology/",
  },
];

export const LINKS = [
  {
    title: "Products",
    children: PRODUCTS_MENU_LINKS,
  },
  // {
  //   title: "Solutions",
  //   children: SOLUTIONS_MENU_LINKS,
  // },
  {
    title: "Company",
    children: [
      {
        url: "/about",
        title: "About us",
      },
      {
        url: "#case-studies",
        title: "Partners",
      },
      {
        url: externalLinks.blog,
        newTab: true,
        title: "Blog",
      },
      {
        url: "/pricing",
        title: "Pricing",
      },
      {
        url: "/brand/brand-kit.zip",
        title: "Brand Kit",
      },
    ],
  },
  {
    title: "Need help?",
    children: [
      {
        url: "/contact#faq",
        title: "FAQ",
      },
      {
        url: "/contact",
        title: "Contact Us",
      },
    ],
  },
  {
    title: "Developer",
    children: [
      {
        url: externalLinks.documentation,
        title: "Documentation",
      },
    ],
  },
  {
    title: "Legal",
    children: [
      {
        url: externalLinks.privacyPolicy,
        title: "Privacy Policy",
      },
      {
        url: externalLinks.termsOfService,
        title: "Terms of Use",
      },
    ],
  },
];
